import React, { useCallback, useState } from 'react';
import { Dropdown } from 'rsuite';
import _ from 'lodash';

import { useFormBuilderStore } from '../../../pages/builder/state';
import { useModal } from '../../../components/modal';
import { useTracking } from '../../../hooks';

import { ShareForm } from './share-form';
import { WithLogin } from '../../../components';

const ShareFormMenuItem = () => {
  const [sharedForm, setSharedForm] = useState();
  const tracking = useTracking();
  const formId = useFormBuilderStore(state => state.formId);
  const size = useFormBuilderStore(state => state.size);
  const framework = useFormBuilderStore(state => state.framework);
  const form = useFormBuilderStore(state => state.form);

  const { open: openShareForm, close: closeShareForm } = useModal({
    view: WithLogin(ShareForm),
    size: 'sm',
    name: 'share_form',
    align: 'center',
    labelSubmit: null,
    labelCancel: null,
    title: 'Share Form'
  });

  const handleClick = useCallback(
    async () => {
      tracking.sendEvent('form.share');
      const newSharedForm = await openShareForm({
        sharedForm,
        form,
        formId,
        framework,
        size
      });
      closeShareForm();

      if (newSharedForm && Object.keys(newSharedForm).length !== 0) {
        setSharedForm(newSharedForm)
      } else if (_.isObject(newSharedForm) && Object.keys(newSharedForm).length === 0) {
        setSharedForm(null);
      }
    },
    [closeShareForm, form, formId, framework, openShareForm, sharedForm, size, tracking]
  );


  return (
    <Dropdown.Item onSelect={handleClick}>Share form</Dropdown.Item>
  );
};

export { ShareFormMenuItem };
